import React, {useEffect, useState} from "react";
import Header from "./components/header/Header";
import ScrollToTopButton from "./topbutton/Top";
import SplashScreen from "./splashScreen/SplashScreen";
import {splashScreen} from "../portfolio";
import {StyleProvider} from "../contexts/StyleContext";
import {useLocalStorage} from "./hooks/useLocalStorage";
import Education from "../containers/education/Education";
import {Fade, Slide} from "react-reveal";
import "./AboutMe.scss";

const AboutMe = () => {
  const darkPref = window.matchMedia("(prefers-color-scheme: dark)");
  const [isDark, setIsDark] = useLocalStorage("isDark", true);
  const [isShowingSplashAnimation, setIsShowingSplashAnimation] =
    useState(true);

  useEffect(() => {
    if (splashScreen.enabled) {
      const splashTimer = setTimeout(
        () => setIsShowingSplashAnimation(false),
        splashScreen.duration
      );
      return () => {
        clearTimeout(splashTimer);
      };
    }
  }, []);

  const changeTheme = () => {
    setIsDark(!isDark);
  };

  return (
    <div className={isDark ? "dark-mode" : null}>
      <StyleProvider value={{isDark: isDark, changeTheme: changeTheme}}>
        {isShowingSplashAnimation && splashScreen.enabled ? (
          <SplashScreen />
        ) : (
          <>
            <Header />
            <ul class="circles">
                <li></li>
                <li></li>
                <li></li>
                <li></li>
                <li></li>
                <li></li>
                <li></li>
                <li></li>
                <li></li>
                <li></li>
                <li></li>
                <li></li>
                <li></li>
                <li></li>
                <li></li>
                <li></li>
                <li></li>
            </ul>
            <div className="proj-bg-main">
              <div className="proj-bg-div">
                <div className="proj-bg-line"></div>
                <div className="proj-bg-line"></div>
                <div className="proj-bg-line"></div>
                <div className="proj-bg-line"></div>
                <div className="proj-bg-line"></div>
                <div className="proj-bg-line"></div>
                <div className="proj-bg-line"></div>
                <div className="proj-bg-line"></div>
                <div className="proj-bg-line"></div>
              </div>
            </div>
            {/* ---- Introduction ---- */}
            <div className="aboutme-div-main">
                <div className="aboutme-div-row">
                    <div className="aboutme-div-col-big">
                        <span data-text-fill="true" className="aboutme-txt-header">Hello! I am Arbi, a dedicated and creative developer with a passion for shaping the digital world. </span> 
                        <div style={{width:"100%",textAlign: "start",display: "flex",flexDirection: "row",marginBlock:"30px",gap:"5px"}}>
                            <div style={{display: "flex",flexDirection: "column",width:"100%"}}>
                                <span data-text-fill="true" className="aboutme-txt-exp-lbl">.experience </span> 
                                <span data-text-fill="true" className="aboutme-txt-exp">5 years </span> 
                            </div>
                            <div style={{display: "flex",flexDirection: "column",width:"100%"}}>
                                <span data-text-fill="true" className="aboutme-txt-exp-lbl">.location </span> 
                                <span data-text-fill="true" className="aboutme-txt-exp">Tirane, Albania </span> 
                            </div>
                            <div style={{display: "flex",flexDirection: "column",width:"100%"}}>
                                <span data-text-fill="true" className="aboutme-txt-exp-lbl">.freelance </span> 
                                <span data-text-fill="true" className="aboutme-txt-exp">Available </span> 
                            </div>
                        </div>
                        

                    </div>
                    <div className="aboutme-div-col">
                        <div className="aboutme-div-img">  
                            <img
                                alt="Arb Koci"
                                className="aboutme-img"
                                src={require("../assets/images/me1.jpg")}
                            ></img>
                        </div>
                        <div className="aboutme-div-desc">
                            <p>
                                I specialize in developing cross-platform applications and backend systems, with a strong focus on performance, security, and real-world usability. Whether it's mobile apps, desktop tools, or Artificial inteligence, I aim to build seamless, reliable experiences that serve both users and businesses.</p>
                        </div>
                        <div data-framer-component-type="SVG" className="aboutme-mouse" ></div>
                    </div>
                </div>
            </div>

            {/* ---- Story ---- */}
            <div className="aboutme-div-main" style={{marginTop:"300px"}}>
                <div className="aboutme-div-story" data-framer-name="Container">
                    <div className="aboutme-div-story-left" data-framer-name="Left">
                        <span data-text-fill="true" className="aboutme-txt-header-story">With half a decade under my belt, I’ve been building and refining digital products, collaborating with companies across industries, and developing solutions that deliver real impact.</span> 
                    </div>
                    <div className="aboutme-div-story-right" data-framer-name="Right">
                        <h3>
                            I'm a full stack software developer with a strong focus on mobile and web application development, particularly in the FinTech, eCommerce, and logistics industries. Over the past few years, I’ve contributed to impactful projects ranging from secure payment systems and utility service platforms to real-time courier and retail logistics tools. My tech stack is broad — spanning Python, Java, Kotlin, SwiftUI, React Native, TypeScript, C#, and more — allowing me to build across platforms with confidence and flexibility.
                            <br></br><br></br>
                            My career has given me the opportunity to work with notable companies and clients, including contributions to the Albanian Courier’s digital transformation, developing applications for global brands like Zara and Massimo Dutti, and implementing Western Union transactions within the UPay mobile app. I’ve also worked closely with international teams and headquarters, especially in fintech environments, where security, scalability, and user trust are critical. Beyond app development, I’ve built Artificial Inteligence and Machine Learning solutions and designed backend security protocols to ensure data integrity and compliance.
                            <br></br><br></br>
                            What drives me is building real, working systems that solve actual problems — not just writing code, but delivering value. Whether I’m developing mobile experiences for integrated POS devices, designing intuitive user flows in Figma, or adapting systems to meet local and international needs, I care about the details and the bigger picture. I'm always looking to grow, collaborate, and create technology that makes life a little easier, faster, and smarter.
                        </h3>
                    </div>
                </div>
            </div>

            <div className="aboutme-div-main">
                <div className="education-div-hrd">
                    <p className="education-heading-new">.work experience</p>
                    <div className="str-line"></div>
                </div>
<Fade left duration={1000}>
                <div className="aboutme-div-workexp">
                    <div className="aboutme-div-workexp-col" style={{flex:"1 0 0px"}}>
                        <h3 className="aboutme-txt-workexp-year">
                            <span className="spanyearexp">
                                2021-Now
                            </span>
                        </h3>
                    </div>
                    <div className="aboutme-div-workexp-col" style={{flex:"2 0 0px"}}>
                        <div className="aboutme-div-work-title">
                            <h4 className="aboutme-txt-work-title">
                                Unionnet &#40;Wester Union&#41;
                            </h4>
                            <br></br>
                            <p className="aboutme-txt-work-location">
                                Tirane, Albania
                            </p>
                            <p className="aboutme-txt-work-position">
                                Senior Software Developer
                            </p>
                        </div>
                    </div>
                    <div className="aboutme-div-workexp-col" style={{flex:"2 0 0px"}}>
                        <p className="aboutme-job-desc">
                            During my time at Unionet, I started by managing small-scale projects and quickly grew into a lead role, taking full ownership of larger, company-wide initiatives. I was responsible not only for developing robust software solutions but also for designing intuitive user experiences, playing a key role in shaping the digital direction of the company.
                        </p>
                    </div>
                </div>
</Fade>
<Fade right duration={1000}>
                <div className="aboutme-div-workexp">
                    <div className="aboutme-div-workexp-col" style={{flex:"1 0 0px"}}>
                        <h3 className="aboutme-txt-workexp-year">
                            <span className="spanyearexp">
                                2020-2021
                            </span>
                        </h3>
                    </div>
                    <div className="aboutme-div-workexp-col" style={{flex:"2 0 0px"}}>
                        <div className="aboutme-div-work-title">
                            <h4 className="aboutme-txt-work-title">
                                Soft & Solution
                            </h4>
                            <br></br>
                            <p className="aboutme-txt-work-location">
                                Tirane, Albania
                            </p>
                            <p className="aboutme-txt-work-position">
                                Junior Software Developer
                            </p>
                        </div>
                    </div>
                    <div className="aboutme-div-workexp-col" style={{flex:"2 0 0px"}}>
                        <p className="aboutme-job-desc">
                            At Soft & Solution, where I completed my internship, I worked closely with the development team to support backend services and contribute to ongoing projects, gaining hands-on experience in building reliable and scalable software solutions
                        </p>
                    </div>
                </div>
</Fade>
            </div>

            

            <Education />

            <ScrollToTopButton />
          </>
        )}
      </StyleProvider>
    </div>
  );
};

export default AboutMe;
